/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { WardGroupDto } from '../models/ward-group-dto';
import { wardGroupsGetWardGroups } from '../fn/ward-groups/ward-groups-get-ward-groups';
import { WardGroupsGetWardGroups$Params } from '../fn/ward-groups/ward-groups-get-ward-groups';

@Injectable({ providedIn: 'root' })
export class WardGroupsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `wardGroupsGetWardGroups()` */
  static readonly WardGroupsGetWardGroupsPath = '/api/ward-groups';

  /**
   * Get all ward groups.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wardGroupsGetWardGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  wardGroupsGetWardGroups$Response(params?: WardGroupsGetWardGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WardGroupDto>>> {
    const obs = wardGroupsGetWardGroups(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all ward groups.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wardGroupsGetWardGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  wardGroupsGetWardGroups(params?: WardGroupsGetWardGroups$Params, context?: HttpContext): Observable<Array<WardGroupDto>> {
    const resp = this.wardGroupsGetWardGroups$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WardGroupDto>>): Array<WardGroupDto> => r.body)
    );
  }

}
